export enum CheckoutStepType {
  LOGIN_REGISTER = 'loginRegister',
  QUOTE_INFO = 'quoteInfo',
  CONTACT_DETAILS = 'contactDetails',
  SHIPPING_ADDRESS = 'shippingAddress',
  BILLING_INFO = 'billingInformation',
  REVIEW = 'review',
  PAYMENT_PROVIDER_PAGE = 'paymentDetails',
  CONFIRMATION = 'confirmation'
}

export interface MbCheckoutStep {
  id: string;
  name: string;
  routeName: string;
  type: Array<CheckoutStepType>;
  disabled?: boolean;
  isProgressBarStep?: boolean;
  checkoutTypes?: string[];
  allowGuard?: boolean;
  step?: number;
}
